import helper from "./helper";

let getPassOrderUrlWithParameters = helper.getPassOrderUrlWithParameters

export default {
    CHOICES: {
        FIELDS: {
            FIELD_TYPE: (gets = null) => getPassOrderUrlWithParameters(
                "choices|orders|field_type",
                "get",
                {},
                gets
            ),
            ORDER_TYPE: (gets = null) => getPassOrderUrlWithParameters(
                "choices|orders|order_type",
                "get",
                {},
                gets
            ),
            ORDER_STATUS: (gets = null) => getPassOrderUrlWithParameters(
                "choices|orders|order|status",
                "get",
                {},
                gets
            ),
            PURPOSE: (gets = null) => getPassOrderUrlWithParameters(
                "choices|orders|order|purpose",
                "get",
                {},
                gets
            ),
            COLOR: (gets = null) => getPassOrderUrlWithParameters(
                "choices|references|car|color",
                "get",
                {},
                gets
            )
        }
    }
}